import { render, staticRenderFns } from "./HonorBuy.vue?vue&type=template&id=6e8654e3&scoped=true&"
import script from "./HonorBuy.vue?vue&type=script&lang=js&"
export * from "./HonorBuy.vue?vue&type=script&lang=js&"
import style0 from "./HonorBuy.vue?vue&type=style&index=0&id=6e8654e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8654e3",
  null
  
)

export default component.exports